<template>
    <ul class="flex list-none p-0">
        <li v-if="showAppleBadge">
            <a
                :href="promoteApp.appleAppLink"
                target="_blank"
                rel="noopener noreferrer"
                data-native-link
                class="inline-block rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-theme-accent focus-visible:ring-offset-2"
            >
                <img :alt="localizations[lang].promoteApp.downloadAppStore" :src="badges.apple" :class="imageClass" />
            </a>
        </li>
        <li v-if="showAndroidBadge">
            <a
                :href="promoteApp.androidAppLink"
                target="_blank"
                rel="noopener noreferrer"
                data-native-link
                class="inline-block rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-theme-accent focus-visible:ring-offset-2"
            >
                <img
                    :alt="localizations[lang].promoteApp.downloadPlayStore"
                    :src="badges.android"
                    :class="imageClass"
                />
            </a>
        </li>
    </ul>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

// `data-native-link` is what keeps the badges working on Safari: it opts them out
// of the reader's link interceptor on the web host, so the visitor's own tap is
// the navigation iOS hands to the store rather than a `window.open()` the host
// makes on its own behalf. Only anchors that carry it are exempt, so article and
// share links keep going through the host.
export default {
    props: {
        imageClass: {
            type: String,
            default: 'h-8',
        },
    },
    computed: {
        ...mapState(['localizations', 'lang', 'promoteApp']),
        ...mapGetters(['isAndroid', 'isApple']),
        showAppleBadge() {
            return !this.isAndroid && Boolean(this.promoteApp.appleAppLink);
        },
        showAndroidBadge() {
            return !this.isApple && Boolean(this.promoteApp.androidAppLink);
        },
        badges() {
            return {
                android: `${process.env.VITE_URL}/volpe-assets/images/stores-badges/google-play-badge_${this.lang}.png`,
                apple: `${process.env.VITE_URL}/volpe-assets/images/stores-badges/apple-store-badge_${this.lang}.png`,
            };
        },
    },
};
</script>
